<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="log"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="ml-3">
            <div class="bg-white min-height">
              <div class="p-3">
                <!--列表-->
                <el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange"
                               :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
                </el-pagination>
                <el-table stripe :data="dataList" border highlight-current v-loading="listLoading"
                          ref="multipleTable" @selection-change="selsChange">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column prop="userName" label="用户" width="120"></el-table-column>
                  <el-table-column prop="content" label="内容" width=""></el-table-column>
                  <el-table-column prop="addtime" label="时间" width="170">
                    <template slot-scope="scope">
                      {{ scope.row.addtime | formatDateTime }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="状态" width="80"></el-table-column>
                  <el-table-column label="操作" width="70px">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="fa fa-send-o"
                                 @click="handleSend(scope.row,scope.$index)">
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from "../../api/rest";
import util from "../../api/util";
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  components: {HomeSidebar},
  data() {
    return {
      tempForm: {},
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      panel_page: {
        total: 4,
        index: 0,
        size: 20,
      },
      isActive: -1,
      batId: '',
      msgTitle: '',
      sels: [],
      dataList: [],
      tempList: [],
      dlg_add_model: false,
      listLoading: false,
      panel_loading: false,
      formTitle: "",
      collapse: api.storage.get('isCollapse'),
      dayRange: [
        {
          label: '今天',
          value: '1',
        }, {
          label: '三天内',
          value: '3',
        }, {
          label: '七天内',
          value: '7',
        },
        {
          label: '一个月',
          value: '30',
        },
      ]
    }
  },
  methods: {
    shrinkMenu() {
      this.collapse = !this.collapse;
      api.storage.set('isCollapse', this.collapse);
    },
    groupChange(item, index) {
      this.isActive = index;
      this.page.index = 0;
      this.batId = item.id;
      this.msgTitle = item.msgTitle;
      this.getData()
    },
    panel_pagechange(val) {
      this.panel_page.index = val - 1;
    },
    add_model_show() {
      this.tempForm = {}
      this.tempForm.source = 'add'
      this.dlg_add_model = true
      this.formTitle = '添加'
    },
    handleEdit(item, index) {
      this.dlg_add_model = true
      this.tempForm = row
      this.formTitle = '修改'
    },
    handleSend(item, index) {
      let api_url = '/sms/sendSingle'
      let para = {}
      para.id = item.id
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          message: res.message,
          type: res.status,
        });
        item.status = res.message
      })
    },
    handleDelete(item, index) {
      let api_url = "/smslog/delBatLog"
      let para = [item]
      console.log(para)
      this.$confirm("删除将不可恢复", "提示", {
        type: "warning",
      }).then(() => {
        api.remote.doPost(para, api_url).then((res) => {
          this.listLoading = false
          this.$message({
            message: res.message,
            type: res.status,
          });
          this.getPanelList()
        })
      })
    },
    // 批量删除
    batchRemove: function () {

    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.getData();
    },
    getData() {
      let para = this.page
      para.batId = this.batId
      let api_url = "/syslog/list"
      this.listLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.listLoading = false;
        this.dataList = res.content;
        this.page.total = res.totalElements;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
  },
  filters: {
    formatDateTime(time) {
      var date = new Date(time)
      return date.toLocaleString()
    }
  },
  mounted() {
    this.getData();
  },
};
</script>



// WEBPACK FOOTER //
// SysLog.vue?2a4a4b94